import { AlertTitle } from "@mui/material";
import React, { useEffect, useRef } from "react";
import { IMutator } from "sonobello.utilities.react";

import { SessionContextProps } from "../../../../../Context/SessionContext";
import CollapsingAlert from "../../../../Components/CollapsingAlert";
import DispositionErrorAlertValue from "../../Types/DispositionErrorAlertValue";

export const classNames = {
  alert: "phoneNumberDispositionBlockingAlert"
};

type PhoneNumberPropNames = keyof SessionContextProps["phoneNumberErrors"];

export interface IPhoneNumberDispositionBlockingAlert extends IMutator<DispositionErrorAlertValue> {
  /** The id of the alert's onChange payloads. */
  alertId: string;
  /** The property names of the phone numbers which are invalid. */
  invalidPropNames: PhoneNumberPropNames[];
}

/** A simple mapping of the invalid property to its displayed label. */
export const phonePropLabelMap: Record<PhoneNumberPropNames, string> = {
  homePhoneNumber: "Home Phone",
  workPhoneNumber: "Work Phone",
  phoneNumber: "Default Phone"
};

/** Returns a flag indicating if the two key arrays have functional equivalency. */
const areEqual = (source: PhoneNumberPropNames[], target: PhoneNumberPropNames[]): boolean => {
  if (source.length !== target.length) return false;
  for (let x = 0; x < source.length; x++) if (!target.some(t => t === source[x])) return false;
  return true;
};

const PhoneNumberDispositionBlockingAlert: React.FC<IPhoneNumberDispositionBlockingAlert> = ({
  alertId,
  invalidPropNames,
  onChange
}) => {
  const invalidPropNamesRef = useRef<PhoneNumberPropNames[] | undefined>(undefined);
  useEffect(() => {
    if (!invalidPropNamesRef.current || !areEqual(invalidPropNames, invalidPropNamesRef.current))
      onChange(new DispositionErrorAlertValue(alertId, invalidPropNames.length > 0));
    invalidPropNamesRef.current = invalidPropNames;
  }, [invalidPropNames]);
  return (
    <CollapsingAlert className={classNames.alert} severity="error" show={invalidPropNames.length > 0}>
      <AlertTitle>Dispositioning is blocked because the following phone numbers above are not allowed:</AlertTitle>
      {`${invalidPropNames.map(propName => phonePropLabelMap[propName]).join(", ")}.`}
    </CollapsingAlert>
  );
};

export default PhoneNumberDispositionBlockingAlert;
